window.ImageCell = function() {
    var el = this;
    var isMoving = false;
    var elsList = {};

    el.remove = function() {
        if (el._parent.hasOwnProperty('upImages')) {
            el.upImages.unsetUsedImage(
                el.workData.workareas[el.selectWorkareaId].images[el.selectId].name);
        }

        delete el._parent.workData.workareas[el.selectWorkareaId].images[el.selectId];

        el.selection.hide();
        el.history.add();
    };

    el.beginMove = function() {
        isMoving = true;
        el._parent.isTransforming = true;
        var moveBtn = document.getElementById('move-image-btn');
        if (moveBtn) {
            moveBtn.style.opacity = 0;
        }
        var element = document.getElementById(
            'images-item-' + el.selectWorkareaId + '-' + el.selectId);

        elsList = {
            element: element,
            clipElement: document.getElementById(
                'cell-clippath-rect-' + el.selectWorkareaId + '-' + el.selectId),
            coord: el.transform.getPosition(element),
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0,
        };
    };

    el.move = function(event) {
        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX -
                    elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY -
                    elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            var reversal = el._parent.workData.workareas[el.selectWorkareaId];
            var image = reversal.images[el.selectId];
            var element = elsList.element;
            var imagePosElement = el.transform.getArea(element);
            var clipPosElement = el.transform.getArea(elsList.clipElement);

            if (
                (
                    clipPosElement.x1 >= imagePosElement.x1 + movementX
                    && clipPosElement.x2 <= imagePosElement.x2 + movementX
                    && clipPosElement.y1 >= imagePosElement.y1 + movementY
                    && clipPosElement.y2 <= imagePosElement.y2 + movementY)
                || el._parent.hasOwnProperty('isTemplater')
                || image.hasOwnProperty('mask')
            ) {

                movementX /= el.workarea.workAreaScale;
                movementY /= el.workarea.workAreaScale;

                elsList.x += movementX;
                elsList.y += movementY;

                var pos = {
                    x: Math.ceil(elsList.coord.x + elsList.x),
                    y: Math.ceil(elsList.coord.y + elsList.y),
                };

                el.transform.setPosition(element, pos.x, pos.y);

                var rotate = el.transform.getRotate(element);
                image.rotate_angle = rotate.angle;
                image.rotate_x = rotate.x;
                image.rotate_y = rotate.y;

                image.x = pos.x;
                image.y = pos.y;
            }
        }
    };

    el.endMove = function() {
        if (isMoving) {
            isMoving = false;
            var moveBtn = document.getElementById('move-image-btn');
            if (moveBtn) {
                moveBtn.style.opacity = 1;
            }
            el.history.add();
        }
    };

    el.resize = function(diff) {
        var element, reversal, image, cell, data = {};
        reversal = el._parent.workData.workareas[el.selectWorkareaId];

        image = reversal.images[el.selectId];
        cell = reversal.cells[el.selectId];
        element = document.getElementById('images-item-' + el.selectWorkareaId + '-' + el.selectId);

        var ratio = image.width / image.height;

        if (
            (
                cell.x >= image.x - diff
                && cell.x + cell.width <= image.x + image.width + diff
                && cell.y >= image.y - parseInt(diff / ratio, 10)
                && cell.y + cell.height <= image.y + image.height + parseInt(diff / ratio, 10)
            )
            || el._parent.hasOwnProperty('isTemplater')
            || image.hasOwnProperty('mask')
        ) {
            data.x = parseInt(image.x) - diff;
            data.y = parseInt(image.y) - parseInt(diff / ratio, 10);
            data.width = parseInt(image.width) + 2 * diff;
            data.height = parseInt(image.height) + parseInt(2 * diff / ratio, 10);

            image.x = data.x;
            image.y = data.y;
            image.width = data.width;
            image.height = data.height;

            element.setAttribute('width', data.width);
            element.setAttribute('height', data.height);
            element.setAttribute('x', data.x);
            element.setAttribute('y', data.y);

            el.history.add();
        }
    };

    el.rotate = function(angle) {
        var element, image;

        image = el._parent.workData.workareas[el.selectWorkareaId].images[el.selectId];
        element = document.getElementById('images-item-' + el.selectWorkareaId + '-' + el.selectId);

        // reset position
        el.upImages.reinitImagePosition(el.selectWorkareaId, el.selectType, el.selectId);
        element.setAttribute('x', image.x);
        element.setAttribute('y', image.y);
        element.setAttribute('width', image.width);
        element.setAttribute('height', image.height);

        // add rotate
        el.transform.addRotate(element, angle);
        var rotate = el.transform.getRotate(element);
        image.rotate_angle = rotate.angle;
        image.rotate_x = rotate.x;
        image.rotate_y = rotate.y;

        // reinit position with angle
        el.upImages.reinitImagePosition(el.selectWorkareaId, el.selectType, el.selectId);
        element.setAttribute('x', image.x);
        element.setAttribute('y', image.y);
        element.setAttribute('width', image.width);
        element.setAttribute('height', image.height);

        el.history.add();
    };
};